<div *nzModalTitle>
  Set min and max
</div>

<div> 
  <div style="display: flex; justify-content: space-between; align-items: stretch; gap: 10px; margin-bottom: 20px;">
    <div style="flex: 1 0 50px">
      <h3 style="font-size: 15px; color: #555; text-align: center;">Inline</h3>
      <div class="grid-table">
        <div class="label-cell">Min</div>
        <div class="middle-bar">:</div> 
        <div class="cell">{{viewerSettings.trueMin()['inline'] | number: '1.2-2'}}</div>
        
        <div class="label-cell">Max</div>
        <div class="middle-bar">:</div> 
        <div class="cell">{{viewerSettings.trueMax()['inline'] | number: '1.2-2'}}</div>
      </div>
    </div>

    <!-- crossline and depth is only relevant for 3D jobs -->
    @if(!is2D()){
      <div style="flex: 1 0 50px; border-left:1px solid rgba(0, 0, 0, 0.1); border-right:1px solid rgba(0, 0, 0, 0.1);;">
        <h3 style="font-size: 15px; color: #555; text-align: center;">Crossline</h3>
        <div class="grid-table">
          <div class="label-cell">Min</div>
          <div class="middle-bar">:</div> 
          <div class="cell">{{viewerSettings.trueMin()['crossline'] | number: '1.2-2'}}</div>

          <div class="label-cell">Max</div>
          <div class="middle-bar">:</div> 
          <div class="cell">{{viewerSettings.trueMax()['crossline'] | number: '1.2-2'}}</div>
        </div>
      </div>
      <div style="flex: 1 0 50px;">
        <h3 style="font-size: 15px; color: #555; text-align: center;">Depth</h3>
        <div class="grid-table">
          <div class="label-cell">Min</div>
          <div class="middle-bar">:</div>
          <div class="cell">{{viewerSettings.trueMin()['depth'] | number: '1.2-2'}}</div>

          <div class="label-cell">Max</div>
          <div class="middle-bar">:</div>
          <div class="cell">{{viewerSettings.trueMax()['depth'] | number: '1.2-2'}}</div>
        </div>
      </div>
    }
  </div>


  <div>
    <form nz-form [formGroup]="minMaxForm" (ngSubmit)="handleOk()">
      <div style="display: flex; justify-content: space-between;">
        <nz-form-item style="display: flex; align-items: center;">
          <nz-form-label [nzNoColon]="true">Auto</nz-form-label>
          <nz-switch formControlName='auto'></nz-switch>
        </nz-form-item>
        @if(projectDefaults){
        <button nz-button type="button" (click)="useProjectDefualts()">
          Use defaults
          <b style="font-size: 12px;">
            [{{projectDefaults.min}} -
            {{projectDefaults.max}}]
          </b>
        </button>
        }
      </div>

      @if(zeroCenteredModel()){
        <nz-form-item class="floating-label">
          <nz-form-label nzFor="minVal" [nzNoColon]="true">Zero Centered Value</nz-form-label>
          <nz-form-control nzErrorTip="Value can not be null!">
            <input type="number" nz-input placeholder="Enter zero centered value" id="minVal" required formControlName="maxValue" />
          </nz-form-control>
        </nz-form-item>
        @if(viewerSettings.showDepthSlice()){
          <nz-divider style="margin: 10px 0;"></nz-divider>
          <div style="text-align: center; margin-bottom: 20px; font-weight: bold;">Depth Slice</div>

          <nz-form-item class="floating-label">
            <nz-form-label nzFor="minVal" [nzNoColon]="true">Zero Centered Value</nz-form-label>
            <nz-form-control nzErrorTip="Depth Value can not be null!">
              <input type="number" nz-input placeholder="Enter zero centered value" id="minVal" required formControlName="depthMaxValue" />
            </nz-form-control>
          </nz-form-item>
        }
      }@else{
        <!-- Normal min max form -->
          <nz-form-item class="floating-label">
            <nz-form-label nzFor="minVal" [nzNoColon]="true">Minimum Value</nz-form-label>
            <nz-form-control nzErrorTip="Minimum value can not be null!">
              <input type="number" nz-input placeholder="Enter minimum value" id="minVal" required formControlName="minValue" />
            </nz-form-control>
          </nz-form-item>
          
          <nz-form-item class="floating-label">
            <nz-form-label nzFor="maxVal" [nzNoColon]="true">Maximum Value</nz-form-label>
            <nz-form-control nzErrorTip="Maximum value can not be null!">
              <input type="number" nz-input placeholder="Enter maximum value" id="maxVal" required formControlName="maxValue" />
            </nz-form-control>
          </nz-form-item>

          
          @if(viewerSettings.showDepthSlice() && !is2D()){
            <nz-divider style="margin: 10px 0;"></nz-divider>
            <div style="text-align: center; margin-bottom: 20px; font-weight: bold;">Depth Slice</div>
            <nz-form-item class="floating-label">
              <nz-form-label nzFor="minVal" [nzNoColon]="true">Minimum Value</nz-form-label>
              <nz-form-control nzErrorTip="Depth Minimum value can not be null!">
                <input type="number" nz-input placeholder="Enter minimum value" id="minVal" required formControlName="depthMinValue" />
              </nz-form-control>
            </nz-form-item>
            
            <nz-form-item class="floating-label">
              <nz-form-label nzFor="maxVal" [nzNoColon]="true">Maximum Value</nz-form-label>
              <nz-form-control nzErrorTip="Depth  Maximum value can not be null!">
                <input type="number" nz-input placeholder="Enter maximum value" id="maxVal" required formControlName="depthMaxValue" />
              </nz-form-control>
            </nz-form-item>
          }
      }

      <!-- this is a shadow button, to cause a submission on enter -->
      <button type="submit" style="display: none"></button>

    </form>
  </div>
</div>


<div *nzModalFooter>
  <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
  <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isConfirmLoading" [disabled]="!minMaxForm.valid">Okay</button>
</div>